const STORAGE_KEY = "recentSearches";
const MAX_RECENT_SEARCHES = 5;

export const readRecentSearches = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
};

export const writeRecentSearches = (searches) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(searches.slice(0, MAX_RECENT_SEARCHES)));
  } catch {
    // Storage can be disabled or full. Recent searches are a convenience, not state we must keep.
  }
};

export const saveRecentSearch = (result) => {
  writeRecentSearches([result, ...readRecentSearches().filter((search) => search.path !== result.path)]);
};
